import { create } from 'zustand';
import { DrugItem } from 'src/api/types';

interface State {
  setTopDrugsList: (topDrugsList: DrugItem[]) => void;
  topDrugsList: DrugItem[];
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const useTopDrugsStore = create<State>()((set) => ({
  setTopDrugsList: async (list) => {
    set({ topDrugsList: list });
  },
  topDrugsList: [],
  isLoading: false,
  setIsLoading: async (isLoading) => {
    set({ isLoading });
  }
}));

export default useTopDrugsStore;
